export default "__VITE_ASSET__BkywYqHS__"